import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LocalServiceService } from '../../../shareModule/services/local-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../environments/environment';
import { CustomerService } from 'src/app/shareModule/services/customer.service';

@Component({
  selector: 'app-activity-log',
  templateUrl: './activity-log.component.html',
  styleUrls: ['./activity-log.component.scss']
})
export class ActivityLogComponent implements OnInit {
  private modalRef: any;
  activityLog: any = {
    totalItems: 0,
    totalPages: 0,
    currentPage: 0,
    data: []
  };

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private local: LocalServiceService,
  ) { }

  ngOnInit(): void {
    this.initData();
  }

  initData(page = 1) {
    this.auth.getActivityLog(page).subscribe((response: any) => {
      this.activityLog = response.body;
    }, (e) => {
      if (e.status == 400) {
        this.toastr.error(e.error.message);
      }
    });
  }

  handleDelete(id: any) {
    this.local.alertConfirm({ message: 'Are you sure you want to delete this cashback?' }).then((res: any) => {
      if (res.isConfirmed) {
        this.auth.shop_business_delete(id).subscribe((response: any) => {
          this.toastr.success('Deleted successfully')
          this.initData()
        }, (e) => {
          this.toastr.error(e.error.message)
        })
      }
    })
  }

}
